import React, { Component } from "react"
import MetaTags from "react-meta-tags"
import { Button, Card, CardBody, CardTitle, Col, Spinner, Form, FormGroup, Input, Label, Row } from "reactstrap"
import ido from "idexo-sdk"
const apiKey = "YsqBLMOEWR48QRiKVt2CR4eU89oDK5zQa0Ib6c29"
const apiKey1 = "yNbIZOVLk51eMqd6cT4CJ2KLJ28VManN6UOOVIhX"
const bscPostUrl = "https://idexobsc.idexo.io"

class CreateMinter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedFiles: [],
            name: "",
            symbol: "",
            loading: false
        }
    }

    handleAcceptedFiles = (files) => {
        files.map((file) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: this.formatBytes(file.size)
            })
        )

        this.setState({ selectedFiles: files })
    }

    handleSubmit = (event) => {
        this.setState({ loading: true })
        event.preventDefault()
        this.sendCreate(this.state.name, this.state.symbol).then(() => {
            this.setState({ loading: false })
        })
    }

    deployBEP721 = (name, symbol, event) => {
        event.preventDefault()
        const transactionType = "createBEP721"
        const apiUrl = "https://nigxx0onpl.execute-api.us-east-1.amazonaws.com/default/bscnft721"
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "x-api-key": apiKey
            },
            body: JSON.stringify({
                name: name,
                symbol: symbol,
                transactionType: transactionType
            })
        })
            .then((res) => res.json())
            .then((data) => {
                console.log("Success: ", data)
            })
            .catch((error) => {
                console.error(error)
            })
    }

    sendCreate = async (name, symbol) => {
        const contract = await ido.React.createBEP721Test(name, symbol, apiKey1)
        const { data, status, statusText } = contract
        if (status === 200) {
            alert(`Contract successfully deployed. Address is: ${data}`)
        } else {
            alert(`Contract deployment failed. StatusCode: ${status}. Reason: ${statusText}`)
        }
    }

    formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) return "0 Bytes"
        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

        const i = Math.floor(Math.log(bytes) / Math.log(k))
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    }

    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <MetaTags>
                        <title>Create NFT Minter</title>
                    </MetaTags>

                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">Create NFT Minter</CardTitle>
                                    <p className="card-title-desc">
                                        Provide a name and a symbol for your minter and select your network.
                                    </p>

                                    <Form onSubmit={this.handleSubmit}>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="name">Name</Label>
                                                    <Input
                                                        id="name"
                                                        name="name"
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => this.setState({ name: e.target.value })}
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="symbol">Symbol</Label>
                                                    <Input
                                                        id="symbol"
                                                        name="symbol"
                                                        type="text"
                                                        className="form-control"
                                                        onChange={(e) => this.setState({ symbol: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>

                                            <Col sm="6">
                                                <FormGroup className="mb-3">
                                                    <Label className="control-label">Network</Label>
                                                    <select className="form-control select2">
                                                        <option>Select</option>
                                                        <option value="BSC">Binance Smart Chain</option>
                                                    </select>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <div className="d-flex flex-wrap gap-2">
                                            <Button
                                                type="submit"
                                                color="primary"
                                                className="waves-effect waves-light"
                                                disabled={this.state.loading}
                                            >
                                                {this.state.loading ? <Spinner size="sm" color="light" /> : "Create"}
                                            </Button>
                                            <Button
                                                type="submit"
                                                color="secondary"
                                                className="waves-effect waves-light"
                                            >
                                                Cancel
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}

export default CreateMinter
